export const AsyncSearch = {
    REQUEST_ASYNC_SEARCH: 'REQUEST_ASYNC_SEARCH',
    RECEIVE_ASYNC_SEARCH: 'RECEIVE_ASYNC_SEARCH',
};
